
// Hide menu anchors on desktop
const isDesktop = window.matchMedia("(min-width: 769px)");

function hideAllAnchors() {
    const menuLists = document.querySelectorAll(".mega-menu__linklist.unstyled-list");

    menuLists.forEach(ul => {
        const anchors = ul.querySelectorAll("a.h6[href='#']");

        anchors.forEach(anchor => {
            anchor.style.display = isDesktop.matches ? "none" : "block";
        });
    });
}

// Run on load
document.addEventListener("DOMContentLoaded", hideAllAnchors);

// Run when screen size changes
isDesktop.addEventListener("change", hideAllAnchors);




document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".watch-video-trigger");
  if (!trigger) return;

  trigger.addEventListener("click", () => {
    // Get all gallery media items
    const mediaItems = document.querySelectorAll(".product-gallery__media");
    if (!mediaItems.length) return;

    // The last media is our video
    const targetMedia = mediaItems[mediaItems.length - 1];

    // Click the thumbnail that corresponds to this media
    const mediaId = targetMedia.getAttribute("data-media-id");
    const thumbnails = document.querySelectorAll(".product-gallery__thumbnail");
    thumbnails.forEach(btn => {
      if (btn.getAttribute("data-media-id") === mediaId) {
        btn.click();
      }
    });

    // Play the video after short delay
    setTimeout(() => {
      const videoMedia = targetMedia.querySelector("video-media");
      if (videoMedia) {
        if (typeof videoMedia.play === "function") {
          videoMedia.play();
        } else {
          const shadowPlayButton = videoMedia.shadowRoot?.querySelector("svg[part='play-button']");
          if (shadowPlayButton) shadowPlayButton.click();
        }
      }
    }, 300);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[data-block-type="accordion"]').forEach(function(block) {
    const kiwiChart = block.querySelector('#KiwiSizingChart');

    if (kiwiChart) {
      // Hide initially to prevent flash
      block.style.display = "none";

      // Observe kiwiChart for changes
      const observer = new MutationObserver(function(mutations, obs) {
        // If Kiwi injected any content
        if (kiwiChart.innerHTML.trim() !== "") {
          block.style.display = ""; // show the accordion
          obs.disconnect(); // stop observing
        }
      });

      observer.observe(kiwiChart, { childList: true, subtree: true });
    }
  });
});
